var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfomodelBindTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.005a2 2 0 10-2.558 1.92v1.999l-3.439 3.412-3.446-3.42V5.919a2 2 0 10-1.126 0V8.37L9.43 12.37v1.692a2 2 0 101.126 0v-1.679l3.999-3.999V5.924A2 2 0 0016 4.005z",
    fill: "#191C26",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B65EE",
    cx: 14,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B65EE",
    cx: 6,
    cy: 4,
    r: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfomodelBindTemplate);
export default __webpack_public_path__ + "static/assets/infomodel-bind-template.0d6eb93e.svg";
export { ForwardRef as ReactComponent };